import styled from "styled-components";

export const LayoutContainerStyled = styled.div`
    &.layout_wrapper {
        position: relative;
        display: inline-flex;
        flex: 1;
        width: 100%;
        overflow: hidden;
        flex-direction: ${(props) => (props.isDocument ? 'column' : 'row')};
        justify-content: ${(props) => (props.isGrid ? 'center' : 'flex-start')};
        align-items: ${(props) => (props.isGrid ? 'center' : 'flex-start')};

        & div { margin: 0; }
    }    

    & .item {
        position: relative;
        box-sizing: border-box;
        border: 1px solid #1a1d25;
        background-color: #000;
        margin: 0;
        box-sizing: border-box;
        overflow: hidden;

        .videoWrap {
            overflow: hidden;
            width: 100%;
            height: 100%;
            position: relative;
            box-sizing: border-box;
            video {
                width: 100%; height: 100%;
            }
        }

        &_true {
            .videoWrap { 
                border: 1px solid #f9bb3d; 
                video {
                    transform: scale(-1, 1);
                    -moz-transform: scale(-1, 1);
                    -webkit-transform: scale(-1, 1);
                    -o-transform: scale(-1, 1);
            
                    object-fit: contain;
                }  
            }
        }

        &.noPin {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            gap: 12px;
        }
    }

    .namePlate {
        position: absolute;
        width: 100%; height: 5%;
        box-sizing: border-box; bottom: 0;
        background: rgba(0,0,0, 0.7); color:#eee; 
        overflow: hidden; 
        padding: 0 10px; font-size: 12px; 
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        min-height: 25px;
        
        > * {
            margin: 0;
        }
    
        .mike {float: right;}
    }

    .voice {
        display: inline-flex;
        .cover {
            display: grid;
            grid-template-columns: 1fr 1fr;
            align-items: center;
            justify-content: center;
        }
        .pin {
            display: inline-flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
        }
    }
`;

export const StyledLayoutContainer = styled.div`
    & video {
        transform: ${(props) => (props.isLocal ? "scale(-1, 1)" : "auto")};
        -moz-transform: ${(props) => (props.isLocal ? "scale(-1, 1)" : "auto")};
        -webkit-transform: ${(props) => (props.isLocal ? "scale(-1, 1)" : "auto")};
        -o-transform: ${(props) => (props.isLocal ? "scale(-1, 1)" : "auto")};

        object-fit: contain;
    }    
`;
